export default __webpack_public_path__ + "static/media/T12.ff598bd7.png";